/* eslint-disable */
import { ArrowRight, Check, X } from 'lucide-react';
import VariantTable from '@/Pages/Food Products/VariantPrice/VariantTable';

// Static sample data for now; will be populated from the backend later.
const INTEGRATION_TRANSACTIONS = [
	{
		type: 'Vendor Order',
		code: 'VENDOR_ORDER',
		description: 'Purchase order raised on a vendor',
	},
	{
		type: 'Vendor Order Fulfillment',
		code: 'VENDOR_ORDER_FULFILLMENT',
		description: 'GRN / receipt against a vendor order',
	},
	{
		type: 'Material Transfer Order',
		code: 'MATERIAL_TRANSFER_ORDER',
		description: 'Item transfer order between locations',
	},
	{
		type: 'Material Transfer Fulfillment',
		code: 'MATERIAL_TRANSFER_FULFILLMENT',
		description: 'Dispatch / receipt against a transfer order',
	},
	{
		type: 'Production Order',
		code: 'PRODUCTION_ORDER',
		description: 'Order to produce finished goods',
	},
	{
		type: 'Production Order Fulfillment',
		code: 'PRODUCTION_ORDER_FULFILLMENT',
		description: 'Output booking against a production order',
	},
	{
		type: 'Indent Issue',
		code: 'INDENT_ISSUE',
		description: 'Material indent raised for issue',
	},
	{
		type: 'Indent Issue Fulfillment',
		code: 'INDENT_ISSUE_FULFILLMENT',
		description: 'Material issued against an indent',
	},
];

const CUSTOMER_MAPPINGS = [
	{
		customerName: 'Nandana',
		partnerCode: 'BC',
		partnerName: 'Business Central',
		transactions: [
			{ type: 'Vendor Order', from: 'BC', to: 'UY', active: true },
			{ type: 'Vendor Order Fulfillment', from: 'UY', to: 'BC', active: false },
			{ type: 'Material Transfer Order', from: 'BC', to: 'UY', active: true },
			{ type: 'Material Transfer Fulfillment', from: 'UY', to: 'BC', active: false },
			{ type: 'Production Order', from: 'UY', to: 'BC', active: false },
			{ type: 'Production Order Fulfillment', from: 'UY', to: 'BC', active: false },
			{ type: 'Indent Issue', from: 'UY', to: 'BC', active: false },
			{ type: 'Indent Issue Fulfillment', from: 'UY', to: 'BC', active: false },
		],
	},
];

const columns = [
	{
		title: 'S.No',
		key: 'sno',
		width: 70,
	},
	{
		title: 'Transaction Type',
		key: 'type',
		width: 200,
	},
	{
		title: 'Code',
		key: 'code',
		width: 200,
	},
	{
		title: 'Description',
		key: 'description',
		width: 220,
	},
	{
		title: 'Data Flow',
		key: 'dataFlow',
		width: 230,
	},
	{
		title: 'Status',
		key: 'status',
		width: 130,
	},
];

const NODE_LABELS = {
	BC: 'Business Central',
	UY: 'UY',
};

const FlowNode = ({ node }) => (
	<span
		className={`rounded px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${
			node === 'UY'
				? 'bg-gray-100 text-gray-800'
				: 'bg-blue-100 text-blue-700'
		}`}
	>
		{NODE_LABELS[node] ?? node}
	</span>
);

const customRowData = {
	sno: (row, index, key, absoluteIndex) => (
		<span className='text-gray-500'>{(absoluteIndex ?? index) + 1}</span>
	),
	code: (row) => (
		<span className='rounded bg-gray-100 px-1.5 py-0.5 font-mono text-xs whitespace-nowrap'>
			{row.code}
		</span>
	),
	dataFlow: (row) => (
		<span className='inline-flex items-center gap-2 whitespace-nowrap'>
			<FlowNode node={row.from} />
			<ArrowRight size={14} className='text-[#4a70fb]' />
			<FlowNode node={row.to} />
		</span>
	),
	status: (row) => (
		<span
			className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${
				row.active
					? 'bg-green-50 text-green-700'
					: 'bg-red-50 text-red-600'
			}`}
		>
			{row.active ? <Check size={13} /> : <X size={13} />}
			{row.active ? 'Active' : 'Disabled'}
		</span>
	),
};

const Integrations = () => {
	return (
		<div className='flex flex-col w-full p-4 gap-5 text-left'>
			{CUSTOMER_MAPPINGS.map((customer) => {
				const tableData = customer.transactions.map((txn) => {
					const master = INTEGRATION_TRANSACTIONS.find(
						(t) => t.type === txn.type
					);
					return {
						id: `${customer.customerName}-${master?.code ?? txn.type}`,
						type: txn.type,
						code: master?.code ?? '-',
						description: master?.description ?? '-',
						from: txn.from,
						to: txn.to,
						active: txn.active,
					};
				});
				return (
					<div
						key={customer.customerName}
						className='border border-gray-200 rounded-lg overflow-hidden'
					>
						<div className='px-4 py-3 border-b border-gray-200 bg-gray-50'>
							<span className='font-semibold text-sm'>
								Customer Integrations
							</span>
							<p className='text-xs text-gray-500 m-0'>
								Which transactions are integrated per customer,
								with data flow direction and status.
							</p>
						</div>
						<div className='flex items-center gap-3 flex-wrap px-4 py-3 border-b border-gray-200'>
							<div className='flex items-center gap-2.5'>
								<div className='flex h-9 w-9 items-center justify-center rounded-full bg-[#4a70fb] font-bold text-white'>
									{customer.customerName.charAt(0)}
								</div>
								<div className='font-semibold text-sm'>{customer.customerName}</div>
							</div>
							<div className='flex-1' />
							<span className='text-xs text-gray-500'>Integration Partner</span>
							<span className='inline-flex items-center gap-1.5 rounded-md border border-gray-200 px-3 py-1.5 text-sm font-semibold'>
								<span className='flex h-5 w-5 items-center justify-center rounded bg-blue-700 text-[10px] font-bold text-white'>
									{customer.partnerCode}
								</span>
								{customer.partnerName}
							</span>
						</div>
						<VariantTable
							columns={columns}
							data={tableData}
							customRowData={customRowData}
							headerRowClassName='bg-blue-50'
							headerCellClassName='bg-blue-50'
						/>
					</div>
				);
			})}
		</div>
	);
};

export default Integrations;
